import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatUtcToEst(time: string) {
  return dayjs(time)?.tz("America/New_York")?.format("h:mm A");
}
